import {RouterModule} from '@angular/router';
import { AuthGuard } from '../../core/auth.guard';
import { B2CAdminComponent } from './b2c-admin.component';
import { VouchersComponent } from '../../vouchers/vouchers.component';
import { CouponsComponent } from '../../coupons/coupons.component';
import { EventsComponent } from './dashboard/events/events.component';
import { AppointmentsComponent } from '../../appointments/appointments.component';
import { NpsComponent } from './dashboard/nps/nps.component';
import { ImpersonateComponent } from './dashboard/impersonate/impersonate.component';
import { PackageBillingComponent } from './dashboard/package-billing/package-billing.component';
import { SuicidalityComponent } from './dashboard/suicidality/suicidality.component';
import { DynamicReportComponent } from './dashboard/dynamic-report/dynamic-report.component';
import { PlatformRegistrationCountsComponent } from './dashboard/platform-registration-counts/platform-registration-counts.component';

export const B2CAdminRoutesModule = RouterModule.forChild([
    {
        path: '', component: B2CAdminComponent,

    },{
        path: 'clinic-vouchers',
        component: VouchersComponent,
        data: {
            type: 'Voucher Managements',
        }
    },{
        path: 'coupons',
        component: CouponsComponent,
        data: {
            type: 'Coupon Managements',
        }
    },{
        path: 'appointments',
        component: AppointmentsComponent,
        data: {
            type: 'Appoinment Managements',
        }
    },{
        path: 'nps',
        component: NpsComponent,
        data: {
            type: 'Net Promoter Score',
        }
    },{
        path: 'impersonate',
        component: ImpersonateComponent,
        data: {
            type: 'Impersonate',
        }
    },{
        path: 'platform-registration-counts',
        component: PlatformRegistrationCountsComponent,
        data: {
            type: 'Platform Registration Counts',
        }
    },{
        path: 'events',
        component: EventsComponent,
        data: {
            type: 'Events',
        }
    }, {
        path: 'package-billing',
        component: PackageBillingComponent,
        data: {
            type: 'Package Billing',
        }
    },
    {
        path: 'suicidalities',
        component: SuicidalityComponent,
        data: {
            type: 'Suicidalities',
        }
    },
    {
        path: 'dynamic-report',
        component: DynamicReportComponent,
        data: {
            type: 'Dynamic Report',
        }
    },
]);
